import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Modal, Button, Breadcrumb } from "react-bootstrap";
import axios from "axios";
import { MyApi } from "../MyApi";

export default function PhotoGalleryPage() {
  const { catId } = useParams();
  const [gallery, setGallery] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);

  // Lightbox
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");

  const handleClose = () => setShow(false);
  const handleOpen = (img, title) => {
    setSelectedImage(img);
    setSelectedTitle(title);
    setShow(true);
  };

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + "gallery-cat", {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data?.status) {
          // Get category name
          const category = res.data.gallery_category.find(cat => cat.id === catId);
          setCategoryName(category?.gallerytitle || "");

          // Filter gallery for selected category
          const catGallery = res.data.gallery.filter(
            (g) => g.parent_id === catId
          );
          setGallery(catGallery);
        }
      } catch (err) {
        console.error("API Error:", err);
        setGallery([]);
        setCategoryName("");
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [catId]);

  if (loading) return <p className="text-center py-5">Loading gallery...</p>;

  return (
    <>
      {/* Breadcrumb */}
      <div className="BreadcrumbStyle">
        <Container>
          <h1>Photo Gallery</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/photo-gallery" }}>
              Photo Gallery
            </Breadcrumb.Item>
            {categoryName && <Breadcrumb.Item active>{categoryName}</Breadcrumb.Item>}
          </Breadcrumb>
        </Container>
      </div>

      <Container className="py-4">
        <Link to="/photo-gallery">
          <Button variant="outline-primary" className="mb-3">
            Back
          </Button>
        </Link>

        <Row className="g-4">
          {gallery.length > 0 ? (
            gallery.map((item) => (
              <Col md={4} sm={6} xs={6} key={item.id}>
                <div
                  className=" text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleOpen(item.image_url, item.gallerytitle)
                  }
                >
                <div className="gallerycard">
                  <img
                    src={item.image_url}
                    alt={item.gallerytitle}
                    className="img-fluid gallery_img"
                  />
                  </div>
                  {/* <h6 className="mt-2">{item.gallerytitle}</h6> */}
                </div>
              </Col>
            ))
          ) : (
            <p className="text-center">No images found</p>
          )}
        </Row>

        {/* Lightbox */}
        <Modal show={show} onHide={handleClose} centered size="lg">
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body className="text-center">
            <img
              src={selectedImage}
              alt={selectedTitle}
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
}
